
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="1.14 1.14 13.72 13.72">
  <path
    fill="currentColor"
    d="M14.115 13.538a.594.594 0 0 1 .6.587.594.594 0 0 1-.6.59h-5a.594.594 0 0 1-.6-.59.594.594 0 0 1 .6-.587h5zm-.336-11.676a3.004 3.004 0 0 1 .06 4.297l-7.397 7.443a.599.599 0 0 1-.192.128.65.65 0 0 1-.167.06l-4.358.899-.029.004h-.003l-.03.006-.062.002a.614.614 0 0 1-.071-.004l.07.004a.608.608 0 0 1-.105-.009h-.003l-.013-.003a.607.607 0 0 1-.069-.019l.083.021a.613.613 0 0 1-.155-.049l-.012-.006a.599.599 0 0 1-.31-.396l-.002-.007-.003-.013a.573.573 0 0 1-.01-.064l.013.077a.582.582 0 0 1-.013-.156l.003-.037a.338.338 0 0 1 .006-.034l.807-4.298a.582.582 0 0 1 .059-.168A.556.556 0 0 1 2 9.35l6.632-6.672a.604.604 0 0 1 .012-.012l.01-.01.744-.747.05-.043.082-.078a3.146 3.146 0 0 1 4.247.075l.001-.001zM9.085 3.909 2.971 10.06l-.62 3.297 3.342-.69 6.115-6.15-2.723-2.608zm2.506-1.733a1.904 1.904 0 0 0-1.335.562l-.036.03-.296.298 2.722 2.607.318-.32a1.841 1.841 0 0 0-.022-2.647 1.913 1.913 0 0 0-1.35-.53z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'PenEdit',
    }) as DefineComponent
    </script>
    